import React, { useContext, useMemo } from 'react';
import ZoomMediaContext from 'zoom/context/media-context';
import {
  MediaDevice,
  ECameraMenuItemKey,
  TCameraMenuItemKey,
  EVideoMenuItem,
  VideoFooterMenuOption,
} from 'shared/types/video.interface';
import { VIDEO_DATA } from 'shared/constants/zoom-constants';
import { getVideoFooterMenuOption } from 'utils/video-footer-utils';
import { ConferenceButton } from 'components/Button/ConferenceButton/ConferenceButton';

interface CameraButtonProps {
  isStartedVideo: boolean;
  isMirrored?: boolean;
  isBlur?: boolean;
  onCameraClick: () => void;
  onSwitchCamera: (deviceId: string) => void;
  onMirrorVideo?: () => void;
  onBlurBackground?: () => void;
  cameraList?: MediaDevice[];
  activeCamera?: string;
}

const CameraButtonMui = (props: CameraButtonProps) => {
  const {
    isStartedVideo,
    cameraList,
    activeCamera,
    isMirrored,
    isBlur,
    onCameraClick,
    onSwitchCamera,
    onMirrorVideo,
    onBlurBackground,
  } = props;

  const { mediaStream } = useContext(ZoomMediaContext);
  const onMenuItemClick = (key: TCameraMenuItemKey) => {
    switch (key) {
      case ECameraMenuItemKey.mirror:
        onMirrorVideo?.();
        break;
      case ECameraMenuItemKey.blur:
        onBlurBackground?.();
        break;
      default:
        onSwitchCamera(key);
    }
  };

  const menuItems = useMemo((): VideoFooterMenuOption[] => {
    const menuOptions: VideoFooterMenuOption[] = [];

    if (cameraList.length) {
      menuOptions.push(
        ...[
          getVideoFooterMenuOption(
            VIDEO_DATA.selectCamera,
            ECameraMenuItemKey.camera,
            cameraList,
            activeCamera,
            EVideoMenuItem.group,
          ),
          getVideoFooterMenuOption(
            VIDEO_DATA.mirrorMyVideo,
            ECameraMenuItemKey.mirror,
            undefined,
            undefined,
            undefined,
            isMirrored,
          ),
          mediaStream?.isSupportVirtualBackground()
            ? getVideoFooterMenuOption(
                VIDEO_DATA.blurMyBackground,
                ECameraMenuItemKey.blur,
                undefined,
                undefined,
                undefined,
                isBlur,
              )
            : null,
        ],
      );
    }
    return menuOptions.filter(Boolean);
  }, [cameraList, activeCamera, isMirrored, mediaStream, isBlur]);

  return (
    <ConferenceButton
      fullButton={isStartedVideo && Boolean(menuItems)}
      tooltipTitle={`${isStartedVideo ? VIDEO_DATA.stopVideo : VIDEO_DATA.startVideo}`}
      onButtonClick={onCameraClick}
      buttonIconType={isStartedVideo ? 'icon-camera_on' : 'icon-camera_off'}
      isMenuAvailable={isStartedVideo && Boolean(menuItems)}
      menuOptions={menuItems}
      onMenuItemClick={onMenuItemClick}
    />
  );
};
export default CameraButtonMui;
